class BESSAppProjectCreditEnabledDependency extends BESSAppProjectDependency {

    constructor(creditCode, dependencyHandler) {
        super();
        this.subscribeToEvents(
            BESSAppCreditDependencyEvent.eventFor(creditCode),
            (x) => dependencyHandler.handle(x)
        );
    }
}


function creditIsEnabled(isEnabled) {
    return isEnabled;
}

